import { render, staticRenderFns } from "./InventoryAdjustment.vue?vue&type=template&id=5986788c&"
import script from "./InventoryAdjustment.vue?vue&type=script&lang=js&"
export * from "./InventoryAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports